import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import "../styles/clients.css";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import PDFMerger from "pdf-merger-js";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import UndevDeliveriesArchive from "./undevDeliveriesArchive";

const MySwal = withReactContent(Swal2);

const UndevDeliveries = (props) => {
  const [deliveries, setDeliveries] = useState([]);
  const [chooseDev, setChooseDev] = useState([]);
  const [chooseDevFlag, setChooseDevFlag] = useState(false);
  const [option, setOption] = useState(1);

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loadingTxt, setLoadingTxt] = useState("");

  const fetchDev = async () => {
    await fetch("https://apidevkppp.ftpeople.pl/getUndev", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var arr = [];
        data.map((el) => {
          if (arr.filter((p) => p.devId === el.devId).length === 0) {
            arr.push(el);
          }
        });
        setDeliveries(arr);
        setLoading(false);
        setLoading2(false);
        setLoadingTxt("");
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchDev();
    setChooseDev([]);
    setChooseDevFlag(false);
  };

  useEffect(() => {
    getData();
  }, []);

  async function addWatermark(pdfBytes, watermarkText) {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    const pages = pdfDoc.getPages();

    pages.forEach((page) => {
      const { width, height } = page.getSize();

      const fontSize = 16;
      const opacity = 1;
      const rotation = Math.atan2(height, width);

      page.drawText(watermarkText, {
        x: width - 250,
        y: height - fontSize - 5,
        size: fontSize,
        font,
        color: rgb(0, 0, 0),
        opacity,
        rotate: { type: "degrees", angle: 0 },
      });
    });

    const modifiedPdfBytes = await pdfDoc.save();
    return modifiedPdfBytes;
  }

  function blobToArrayBuffer(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(blob);
    });
  }

  const getDevsMulti = async (data) => {
    setLoading(true);
    setLoading2(true);
    var arr = [];

    chooseDev.map((el) => {
      arr.push({
        id: el,
        link: deliveries.filter((p) => +p.devId === +el)[0].link,
      });
    });
    var body = {
      devs: arr,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getDevsMulti", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    }).then((response) => {
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let fullText = "";

      function readChunk() {
        reader.read().then(({ done, value }) => {
          if (done) {
            const jsonStart = fullText.indexOf("JSON_START");
            const jsonEnd = fullText.indexOf("JSON_END");
            if (jsonStart !== -1 && jsonEnd !== -1) {
              const jsonString = fullText.substring(jsonStart + 10, jsonEnd);
              const data = JSON.parse(jsonString);

              console.log(data);
              const zip = new JSZip();

              var count = 0;
              var merger = new PDFMerger();
              var urls = [];
              data.forEach(async function (file) {
                var filename = file.name + "." + file.url.split(".").pop();
                urls.push({ url: file.url, name: filename });
              });
              urls.map(async (url, index) => {
                console.log(url.url);
                const data = await fetch(url.url).then(async (data) => {
                  const blob = await data.blob();

                  blobToArrayBuffer(blob).then(async (arrayBuffer) => {
                    const byteArray = new Uint8Array(arrayBuffer);

                    var date =
                      new Date().getFullYear() +
                      "-" +
                      (new Date().getMonth() + 1 < 10
                        ? "0" + (new Date().getMonth() + 1)
                        : new Date().getMonth() + 1) +
                      "-" +
                      (new Date().getDate() < 10
                        ? "0" + new Date().getDate()
                        : new Date().getDate()) +
                      " " +
                      (new Date().getHours() < 10
                        ? "0" + new Date().getHours()
                        : new Date().getHours()) +
                      ":" +
                      (new Date().getMinutes() < 10
                        ? "0" + new Date().getMinutes()
                        : new Date().getMinutes());

                    const watermark = await addWatermark(
                      byteArray,
                      "Odebrano dnia " + date
                    );

                    zip.file(url.name, new Blob([watermark]));

                    await merger.add(new Blob([watermark])).then(async () => {
                      var time = Math.ceil(urls.length / 30);
                      if (index + 1 === urls.length) {
                        await merger.setMetadata({
                          producer: "KPPP WORKFLOW",
                          author: "Admin KPPP",
                          creator: "PI",
                          title: "Odebrane doręczenia",
                        });

                        fetch(
                          "https://apidevkppp.ftpeople.pl/getUndevDeliveries",
                          {
                            method: "GET",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: secretKey,
                            },
                          }
                        )
                          .then((response) => response.text())
                          .then(async (data) => {
                            setLoadingTxt("Łącze pliki i odświeżam dane");
                            setTimeout(async () => {
                              const mergedPdfBlob = await merger.saveAsBlob();
                              zip.file("połączone.pdf", mergedPdfBlob);
                              zip
                                .generateAsync({ type: "blob" })
                                .then((content) => {
                                  saveAs(content, "odebrane.zip");
                                  getData();
                                });
                            }, time * 30000);
                          });
                      }
                    });
                  });
                });
              });
            } else {
            }
            return;
          }

          const text = decoder.decode(value, { stream: true });

          fullText += text;
          if (!text.includes("JSON_START")) {
            setLoadingTxt(text);
          }

          readChunk();
        });
      }

      readChunk();
    });
  };

  const getDevsMultiOnce = async (data) => {
    setLoading(true);
    setLoading2(true);
    var arr = [];

    chooseDev.map((el) => {
      arr.push({
        id: el,
        link: el.link,
      });
    });
    var body = {
      devs: arr,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getDevsMulti", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    }).then((response) => {
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let fullText = "";

      function readChunk() {
        reader.read().then(({ done, value }) => {
          if (done) {
            const jsonStart = fullText.indexOf("JSON_START");
            const jsonEnd = fullText.indexOf("JSON_END");
            if (jsonStart !== -1 && jsonEnd !== -1) {
              const jsonString = fullText.substring(jsonStart + 10, jsonEnd);
              const data = JSON.parse(jsonString);

              console.log(data);
              const zip = new JSZip();

              var count = 0;
              var merger = new PDFMerger();
              var urls = [];
              data.forEach(async function (file) {
                var filename = file.name + "." + file.url.split(".").pop();
                urls.push(file.url);
              });
              urls.map(async (url, index) => {
                console.log(url);
                const data = await fetch(url);
                const blob = await data.blob();
                blobToArrayBuffer(blob).then(async (arrayBuffer) => {
                  const byteArray = new Uint8Array(arrayBuffer);

                  var date =
                    new Date().getFullYear() +
                    "-" +
                    (new Date().getMonth() + 1 < 10
                      ? "0" + (new Date().getMonth() + 1)
                      : new Date().getMonth() + 1) +
                    "-" +
                    (new Date().getDate() < 10
                      ? "0" + new Date().getDate()
                      : new Date().getDate()) +
                    " " +
                    (new Date().getHours() < 10
                      ? "0" + new Date().getHours()
                      : new Date().getHours()) +
                    ":" +
                    (new Date().getMinutes() < 10
                      ? "0" + new Date().getMinutes()
                      : new Date().getMinutes());

                  const watermark = await addWatermark(
                    byteArray,
                    "Odebrano dnia " + date
                  );

                  await merger.add(new Blob([watermark])).then(async () => {
                    if (index + 1 === urls.length) {
                      await merger.setMetadata({
                        producer: "KPPP WORKFLOW",
                        author: "Admin KPPP",
                        creator: "PI",
                        title: "Odebrane doręczenia",
                      });

                      fetch(
                        "https://apidevkppp.ftpeople.pl/getUndevDeliveries",
                        {
                          method: "GET",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: secretKey,
                          },
                        }
                      )
                        .then((response) => response.text())
                        .then(async (data) => {
                          setLoadingTxt("Łącze pliki i odświeżam dane");
                          setTimeout(async () => {
                            await merger.save(
                              "odebrane " + new Date() + ".pdf"
                            );
                            getData();
                          }, 30000);
                        });
                    }
                  });
                });
              });
            } else {
            }
            return;
          }

          const text = decoder.decode(value, { stream: true });

          fullText += text;
          if (!text.includes("JSON_START")) {
            setLoadingTxt(text);
          }

          readChunk();
        });
      }

      readChunk();
    });
  };

  const devData = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th>Zaznacz</th>
          <th>ID</th>
          <th>Id klienta</th>
          <th>Klient</th>
          <th>Sąd</th>
          <th>Sygnatura</th>
          <th>Data</th>
          <th>Identyfikator</th>
          <th>Akcja</th>
        </tr>
        {deliveries.map((d, index) => (
          <tr>
            <td>
              <input
                style={{ width: "15px", height: "15px", margin: "0" }}
                className="checkInput"
                type="checkbox"
                value={d.devId}
                checked={
                  chooseDev.filter((el) => +el === +d.devId).length > 0
                    ? true
                    : false
                }
                onChange={(e) => {
                  var arr = [];

                  if (
                    chooseDev.filter((q) => +q === +e.target.value).length > 0
                  ) {
                    chooseDev.map((p) => {
                      if (+p !== +e.target.value) {
                        arr.push(p);
                      }
                      return;
                    });
                  } else {
                    arr = chooseDev;
                    arr.push(e.target.value);
                  }
                  if (arr.length > 0) {
                    setChooseDevFlag(true);
                  } else {
                    setChooseDevFlag(false);
                  }
                  setChooseDev(arr);
                }}
              />
            </td>
            <td>{index + 1}</td>
            <td>{d.id_old}</td>
            <td>{d.petitioner}</td>
            <td>{JSON.parse(d.value).court}</td>
            <td>{JSON.parse(d.value).signature}</td>
            <td>{JSON.parse(d.value).publicationDate.split("T")[0]}</td>
            <td>{JSON.parse(d.value).identifier}</td>
            <td>
              {" "}
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={() => {
                  setChooseDev([{ id: d.devId, link: d.link }]);
                  getDevsMultiOnce([{ id: d.devId, link: d.link }]);
                }}
              >
                odbierz
              </button>
            </td>
          </tr>
        ))}
      </table>
    </>
  );

  const devsActual = (
    <>
      <p
        style={{
          fontWeight: "600",
          fontSize: "1.5vw",
          textTransform: "uppercase",
        }}
      >
        Doręczenia do odebrania ({deliveries.length} rekordów)
      </p>

      <>
        <div style={{ display: "flex", gap: "20px", marginBottom: "3vh" }}>
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={() => {
              var arr = [];
              deliveries.map((el) => {
                arr.push(el.devId);
              });
              setChooseDev(arr);
              setChooseDevFlag(true);
            }}
          >
            zaznacz wszystkie
          </button>
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={() => {
              setChooseDev([]);
              setChooseDevFlag(false);
            }}
          >
            odznacz wszystkie
          </button>
          {chooseDevFlag ? (
            <>
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={() => {
                  getDevsMulti();
                }}
              >
                odbierz zbiorczo
              </button>
            </>
          ) : (
            ""
          )}
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={() => {
              getData();
            }}
          >
            odśwież
          </button>
        </div>
      </>

      <div className="desktopFilters">
        <div className="contentBoxPayments">{devData}</div>
      </div>
    </>
  );

  const devsArch = (
    <>
      <UndevDeliveriesArchive />
    </>
  );

  return (
    <>
      {loading ? (
        <>
          <LoadingPopup loading2={loading2} loadingTxt={loadingTxt} />
        </>
      ) : (
        <>
          <div id="reportC" className="mainContainerClients">
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div style={{ display: "flex", gap: "20px" }}>
              <button
                style={{
                  backgroundColor: "green",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={() => {
                  setOption(1);
                }}
              >
                Do odebrania
              </button>
              <button
                style={{
                  backgroundColor: "red",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={() => {
                  setOption(2);
                }}
              >
                Archiwum
              </button>
            </div>

            <>{option === 1 ? devsActual : option === 2 ? devsArch : ""}</>
          </div>
        </>
      )}
    </>
  );
};

export default UndevDeliveries;
